import { Button, ButtonProps, Flex } from "@chakra-ui/react";
import { FC, MouseEvent, useState } from "react";

interface TimerButtonProps extends ButtonProps {
  onConfirm: (event: MouseEvent<HTMLButtonElement>) => void;
  colorScheme: "red" | "green" | "blue";
}

const timerDuration = 2500;
const TimerButton: FC<TimerButtonProps> = ({ onConfirm, colorScheme, children }) => {
  const [timerStarted, setTimerStarted] = useState<boolean>(false);
  const [timerFinsihed, setTimerFinsihed] = useState<boolean>(false);

  const buttonBgColorMap = {
    red: "rgb(242, 100, 100)",
    blue: "rgb(100, 100, 242)",
    green: "rgb(100, 242, 100)",
  };
  const confirmButtonBgColor = buttonBgColorMap[colorScheme];

  return (
    <Button
      ml={3}
      overflow="hidden"
      colorScheme={colorScheme}
      backgroundColor={confirmButtonBgColor}
      _hover={{ bg: confirmButtonBgColor }}
      onClick={(event) => timerFinsihed && onConfirm(event)}
      onTouchStart={() => setTimerStarted(true)}
      onTouchEnd={() => setTimerStarted(false)}
      onMouseEnter={() => setTimerStarted(true)}
      onMouseLeave={() => setTimerStarted(false)}
    >
      <Flex position="relative" width="100%" zIndex="1">
        {children}
      </Flex>
      <Flex
        backgroundColor={colorScheme}
        transform={timerFinsihed || timerStarted ? "translateX(0)" : "translateX(-100%)"}
        transitionDuration={timerDuration + "ms"}
        transitionTimingFunction={"linear"}
        position="absolute"
        height="100%"
        width="100%"
        onTransitionEnd={() => timerStarted && setTimerFinsihed(true)}
      ></Flex>
    </Button>
  );
};

export default TimerButton;
